var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSuccessSWdownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_success_SWdownload@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Single-page-4--1",
    transform: "translate(-338.000000, -1196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_success_SWdownload",
    transform: "translate(338.000000, 1196.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#009527",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3779184,21.4933662 C15.9829599,21.88034 15.3390745,21.8764618 14.9503743,21.4951174 L10.6589472,17.2849018 C10.2654948,16.8988952 9.62510744,16.8991027 9.23277257,17.2813024 L8.71376615,17.7869013 C8.31956399,18.17092 8.3195044,18.7956867 8.7071611,19.1760073 L14.9556216,25.3062213 C15.3461759,25.6893847 15.9801473,25.6886413 16.3794096,25.2969347 L27.2833731,14.5993189 C27.6791552,14.2110267 27.6808323,13.5831259 27.2802852,13.1901588 L26.7868841,12.7060949 C26.3893966,12.3161294 25.7443776,12.3162659 25.3520337,12.7006779 L16.3779184,21.4933662 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessSWdownload);
export default __webpack_public_path__ + "static/media/icon_success_SWdownload.d98eb4e84eab3fc76c57a3d31c8d3b16.svg";
export { ForwardRef as ReactComponent };